module.exports = __webpack_public_path__ + "img/richlite-texture.a453cf0d.jpg";